<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.indicator"></strong>
          </div>
          <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col cols="12" md="">
                <b-form-group
                  :label="$lang.caption"
                  label-for="caption"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.caption"
                    :rules="$v.caption.$params"
                  />
                  <b-form-input
                    id="caption"
                    type="text"
                    autocomplete="off"
                    :state="$v.caption.$dirty ? !$v.caption.$error : null"
                    v-model="$v.caption.$model"
                  ></b-form-input>

                  <b-form-invalid-feedback id="caption-feedback"
                    >{{ $lang.error_required | replace($lang.caption) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="auto">
                <b-form-group
                  :label="`${$lang.type} ${$lang.indicator}`"
                  label-for="value"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.type} ${$lang.indicator}`"
                    :rules="$v.value.$params"
                  />
                  <b-form-radio-group
                    id="value"
                    v-model="$v.value.$model"
                    :state="$v.value.$dirty ? !$v.value.$error : null"
                    :options="value_options"
                    buttons
                    button-variant="outline-primary"
                    name="radios-btn-default"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback
                    :state="$v.value.$dirty ? !$v.value.$error : null"
                    id="value-feedback"
                    >{{
                      $lang.error_required
                        | replace(`${$lang.type} ${$lang.indicator}`)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.indicator_code"
                  label-for="indicatorCode"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.indicator_code"
                    :rules="$v.indicatorCode.$params"
                  />
                  <b-form-input
                    id="indicatorCode"
                    type="text"
                    autocomplete="off"
                    :state="
                      $v.indicatorCode.$dirty ? !$v.indicatorCode.$error : null
                    "
                    v-model="$v.indicatorCode.$model"
                  ></b-form-input>

                  <b-form-invalid-feedback id="indicatorCode-feedback"
                    >{{ $lang.error_required | replace($lang.indicator_code) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.third_person"
                  label-for="caption_third_person"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.third_person"
                    :rules="$v.caption_third_person.$params"
                  />
                  <b-form-textarea
                    id="caption_third_person"
                    v-model="$v.caption_third_person.$model"
                    type="text"
                    :state="
                      $v.caption_third_person.$dirty
                        ? !$v.caption_third_person.$error
                        : null
                    "
                    :autocomplete="$lang.third_person"
                    :rows="5"
                  ></b-form-textarea>

                  <b-form-invalid-feedback id="caption_third_person-feedback">
                    {{
                      $lang.error_required | replace($lang.third_person)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.second_person"
                  label-for="caption_second_person"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.second_person"
                    :rules="$v.caption_second_person.$params"
                  />
                  <b-form-textarea
                    id="caption_second_person"
                    v-model="$v.caption_second_person.$model"
                    :state="
                      $v.caption_second_person.$dirty
                        ? !$v.caption_second_person.$error
                        : null
                    "
                    type="text"
                    :autocomplete="$lang.second_person"
                    :rows="5"
                  ></b-form-textarea>

                  <b-form-invalid-feedback id="caption_second_person-feedback">
                    {{
                      $lang.error_required | replace($lang.second_person)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.imperative"
                  label-for="caption_imperative"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.imperative"
                    :rules="$v.caption_imperative.$params"
                  />
                  <b-form-textarea
                    id="caption_imperative"
                    v-model="$v.caption_imperative.$model"
                    :state="
                      $v.caption_imperative.$dirty
                        ? !$v.caption_imperative.$error
                        : null
                    "
                    type="text"
                    :autocomplete="$lang.imperative"
                    :rows="5"
                  ></b-form-textarea>

                  <b-form-invalid-feedback id="caption_imperative-feedback">
                    {{
                      $lang.error_required | replace($lang.imperative)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.managerial"
                  label-for="caption_managerial"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.managerial"
                    :rules="$v.caption_managerial.$params"
                  />
                  <b-form-textarea
                    id="caption_managerial"
                    v-model="$v.caption_managerial.$model"
                    :state="
                      $v.caption_managerial.$dirty
                        ? !$v.caption_managerial.$error
                        : null
                    "
                    type="text"
                    :autocomplete="$lang.managerial"
                    :rows="5"
                  ></b-form-textarea>

                  <b-form-invalid-feedback id="caption_managerial-feedback">
                    {{
                      $lang.error_required | replace($lang.managerial)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <TagComponent
                  category_name="tag_indicator"
                  :label="$lang.tag"
                  :multiple="true"
                  :requiredLabel="tagInputRequired"
                  :parentPermissions="['admin']"
                  :checkValidation="checkTagSelected"
                  :parentValue="tags"
                  @updateCheckValidation="updateCheckTagSelected"
                  @getSelected="getSelected"
                />
              </b-col>
            </b-row>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import TagComponent from "@/components/tag/tagComponent.vue";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "add-indicator",
  components: { TagComponent, LoadingSpinner },
  validations: {
    caption: {
      required,
    },
    indicatorCode: {},
    value: {
      required,
    },
    caption_third_person: {
      required,
    },
    caption_second_person: {
      required,
    },
    caption_imperative: {},
    caption_managerial: {},
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
    competency: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      caption: "",
      indicatorCode: "",
      value: "",
      caption_third_person: "",
      caption_second_person: "",
      caption_imperative: "",
      caption_managerial: "",
      value_options: [
        {
          value: "1",
          text: this.$lang.positive,
        },
        {
          value: "-1",
          text: this.$lang.negative,
        },
      ],
      tags: [],
      checkTagSelected: false,
      tagInputRequired: false,
    };
  },
  methods: {
    generateApiUrl,
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.caption = "";
      this.indicatorCode = "";
      this.value = "";
      this.caption_third_person = "";
      this.caption_second_person = "";
      this.caption_imperative = "";
      this.caption_managerial = "";
      this.competency_selected = "";
      this.tags = [];
      this.$v.$reset();
    },
    changes() {},
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      this.checkTagSelected = true;
      if (this.tagInputRequired && !this.tags.length) return;

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "indicator"]);
        const payload = {
          caption: this.caption,
          code: this.indicatorCode,
          value: this.value,
          tag_id: this.tags.map((tag) => tag.value),
          caption_third_person: this.caption_third_person,
          caption_second_person: this.caption_second_person,
          caption_imperative: this.caption_imperative,
          caption_managerial: this.caption_managerial,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.handleBack()
        this.$emit("getItems");
        this.clear();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    updateCheckTagSelected(data) {
      this.checkTagSelected = data;
    },
    getSelected(data) {
      this.tags = data;
    },
  },
};
</script>

